var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4444 5.19444H6.80556V1.55556C6.80556 1.11378 6.44177 0.75 6 0.75C5.55823 0.75 5.19444 1.11378 5.19444 1.55556V5.19444H1.55556C1.11378 5.19444 0.75 5.55823 0.75 6C0.75 6.44177 1.11378 6.80556 1.55556 6.80556H5.19444V10.4444C5.19444 10.8862 5.55822 11.25 6 11.25C6.44177 11.25 6.80556 10.8862 6.80556 10.4444V6.80556H10.4444C10.8862 6.80556 11.25 6.44177 11.25 6C11.25 5.55822 10.8862 5.19444 10.4444 5.19444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonAdd);
export default __webpack_public_path__ + "static/media/ButtonAdd.3a430d4a9882e86c6ff9aa77bf6f0b1e.svg";
export { ForwardRef as ReactComponent };